import React from 'react';
import ReactDOM from 'react-dom';
import Loader from '@hobs/components/Loader';

import Styles from './GridLoader.module.scss';

const GridLoader = () => {
  const loadingPanel = (
    <div className={Styles.loader}>
      <Loader />
    </div>
  );

  const gridContent = document && document.querySelector('.k-grid-content');
  return gridContent
    ? ReactDOM.createPortal(loadingPanel, gridContent)
    : loadingPanel;
};

export default GridLoader;
